// Module
var code = "<span class=\"br-caption-2 font-weight-800 text-uppercase\" ng-class=\"$ctrl.task.taskSpec.purpose\" ng-click=\"$ctrl.taskInfoPopup($event)\"> {{$ctrl.task.taskSpec.purpose[0] | translate}} </span> ";
// Exports
export default code;